import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button, Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import {
  savemsg,
  saveWarningMsg,
  serverMsg
} from "../../config/messageconstant";
import { getSalesExecutiveByUserType } from "../../Slice/salesExecutive.slice";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadExcel } from "../PDF/PDFDownload";
import ChangeOutletBeatExportPopUp from "./ChangeOutletBeatExportPopUp";
import ChangeOutletBeatImportPopUp from "./ChangeOutletBeatImportPopUp";
const ExcelJS = require("exceljs");

class ChangeOutletBeatImportExport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: dayjs(),
      toDate: dayjs(),
      salesTeam: "",
      searchValue: "",
      importPopUpFlag: false,
      validatedList: [],
      hasErrorRow: false,
      exportPopUpFlag: false,
    };

    this.tableStyles = {
      tabContainer: {
        display: "flex",
        marginBottom: "16px",
        borderBottom: "1px solid #E5F1F9",
      },
      tableWrapper: {
        maxHeight: "570px",
        overflowY: "auto",
        overflowX: "auto", // Enable horizontal scrolling
        width: "100%",
        border: "1px solid rgb(182, 186, 188)",
        borderRadius: "8px",
      },
      table: {
        width: "max-content", // Allow table to grow based on content
        borderCollapse: "collapse",
        tableLayout: "auto", // Auto layout for flexible column sizing
      },
      stickyHeader: {
        position: "sticky",
        top: 0,
        backgroundColor: "rgb(233, 240, 243)",
        zIndex: 10,
      },
      tab: {
        padding: "8px 16px",
        cursor: "pointer",
        color: "#333",
        fontSize: "14px",
        fontWeight: "500",
        transition: "color 0.2s ease-in-out",
      },
      activeTab: {
        color: "#1C4E80",
        borderBottom: "2px solid #1C4E80",
      },
      noData: {
        padding: "16px",
        textAlign: "center",
        fontSize: "14px",
        color: "#666",
      },
      tableContainer: {
        backgroundColor: "#fff",
        borderRadius: "10px",
        padding: "16px",
        maxWidth: "100%", // Allow full width usage
        margin: "0 auto",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
      },
      searchContainer: {
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        maxWidth: "300px",
      },
      headerRow: {
        backgroundColor: "rgb(233, 240, 243)",
        color: "#000",
        fontWeight: "bold",
        fontSize: "14px",
      },
      headerCell: {
        padding: "12px 8px", // Reduced horizontal padding for better space utilization
        textAlign: "center",
        borderBottom: "2px solid #E5F1F9",
        borderRight: "1px solid #E5F1F9", // Add right border for better column separation
        fontWeight: 600,
        whiteSpace: "nowrap", // Prevent text wrapping in headers
        position: "sticky",
        top: 0,
        backgroundColor: "rgb(233, 240, 243)",
      },
      dataRow: {
        backgroundColor: "#fff",
        transition: "background-color 0.2s ease-in-out",
      },
      dataRowHover: {
        backgroundColor: "#E5F1F9",
      },
      dataCell: {
        padding: "12px 8px", // Reduced horizontal padding
        fontSize: "13px",
        color: "#333",
        borderBottom: "1px solid #E5F1F9",
        borderRight: "1px solid #E5F1F9", // Add right border for better column separation
        whiteSpace: "nowrap", // Prevent text wrapping
        overflow: "hidden",
        textOverflow: "ellipsis", // Show ellipsis for long text
      },
      amountCell: {
        color: "#004969",
        fontWeight: "500",
        fontSize: "13px",
      },
      alternateRow: {
        backgroundColor: "#fff",
      },
      searchInput: {
        width: "100%",
        padding: "8px 12px",
        fontSize: "14px",
        border: "1px solid #E5F1F9",
        borderRadius: "6px",
        outline: "none",
        color: "#333",
        transition: "border-color 0.3s ease-in-out",
      },
      searchInputFocus: {
        borderColor: "#1C4E80",
        boxShadow: "0 0 5px rgba(28, 78, 128, 0.3)",
      },
    };

    this.tableStyles = {
      ...this.tableStyles,
      tableWrapper: {
        maxHeight: "570px",
        overflowY: "auto",
        overflowX: "auto",
        border: "1px solid #dce3eb",
        borderRadius: "8px",
      },
      table: {
        width: "100%",
        borderCollapse: "collapse",
        minWidth: "800px",
      },
      headerCell: {
        padding: "10px 12px",
        textAlign: "center",
        borderBottom: "2px solid #dce3eb",
        backgroundColor: "#f2f6f9",
        fontWeight: 600,
        fontSize: "14px",
        position: "sticky",
        top: 0,
        zIndex: 5,
      },
      dataCell: {
        padding: "10px 12px",
        fontSize: "13px",
        color: "#333",
        borderBottom: "1px solid #eaeaea",
      },
      noData: {
        textAlign: "center",
        padding: "20px",
        fontSize: "14px",
        color: "#888",
        fontStyle: "italic",
      },
    };
  }

  onClickOfExport = () => {
    this.setState({ exportPopUpFlag: true });
  };

  onClickOfImport = () => {
    this.setState({ importPopUpFlag: true });
  };

  onSearchBox = (e) => {
    this.setState({
      searchValue: e.target.value,
    });
  };

  getFilteredTableData = (searchData) => {
    const { searchValue } = this.state;

    return searchData.filter((currentRow) => {
      let isValid = false;

      let outletCode = currentRow?.outletCode;
      let outletName = currentRow?.outletName;
      let beatName = currentRow?.beatName;
      let townName = currentRow?.townName;
      let distributorShCode = currentRow?.distributorShCode;
      let distributorFirmName = currentRow?.distributorFirmName;
      let distributorFirmOwnerName = currentRow?.distributorFirmOwnerName;

      if (
        (outletCode &&
          outletCode
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (outletName &&
          outletName
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (beatName &&
          beatName
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (townName &&
          townName
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (distributorShCode &&
          distributorShCode
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (distributorFirmName &&
          distributorFirmName
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (distributorFirmOwnerName &&
          distributorFirmOwnerName
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  onSubmit = () => {
    const { showLoador, showNotification } = this.props;
    const { validatedList } = this.state;

    let dataToSendList = validatedList.length !== 0 ? validatedList : [];

    swal({
      title: "Are you sure?",
      text: saveWarningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoador({ loador: true });
        apiPost({
          url: endpoint.importData + "/validated-reassign-outlet-beat-data",
          postBody: dataToSendList,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            if (data && data.data && data.data.statusCode == 500) {
              showNotification({
                msg: data.data.message,
                severity: "error",
              });
            } else {
              showNotification({
                msg: savemsg,
              });
              window.location.reload();
            }
          }
        });
      }
    });
  };

  importPopUpClose = () => {
    this.setState({ importPopUpFlag: false });
  };

  exportPopUpClose = () => {
    this.setState({ exportPopUpFlag: false });
  };

  dataMethod = (dataObj) => {
    const hasErrorRow = dataObj.some((item) => item.flag == 1);

    this.setState({ validatedList: dataObj, hasErrorRow });
  };

  render() {
    const { importPopUpFlag, validatedList, hasErrorRow, exportPopUpFlag } =
      this.state;

    return (
      <>
        <Paper
          sx={{
            borderRadius: 2,
            p: { xs: 2, sm: 4 },
            boxShadow: "0 6px 32px rgba(0,0,0,0.08)",
            margin: "auto",
          }}
          elevation={5}
        >
          {/* ===== Header Section ===== */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <LandingScreenHeader
              screenTitle="Import Outlet Moving"
              showSaveBtnMain={false}
              showAddButton={false}
              showBackButton={false}
            />

            <div style={{ display: "flex", gap: 15 }}>
              <Button
                variant="outlined"
                color="secondary"
                startIcon={<CloudDownloadIcon />}
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  minWidth: "120px",
                  height: "36px",
                  "&:hover": {
                    backgroundColor: "#f4f6fa",
                    borderColor: "#1976d2",
                    color: "#1976d2",
                    transform: "translateY(-2px)",
                  },
                }}
                onClick={this.onClickOfExport}
              >
                Export
              </Button>
              <Button
                variant="contained"
                color="primary"
                startIcon={<CloudUploadIcon sx={{ color: "#fff" }} />}
                sx={{
                  color: "#fff",
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  minWidth: "140px",
                  height: "36px",
                  "&:hover": {
                    backgroundColor: "#1976d2",
                    transform: "translateY(-2px)",
                  },
                }}
                onClick={this.onClickOfImport}
              >
                Import
              </Button>
            </div>
          </div>

          {/* ===== Search Bar ===== */}
          <div
            style={{
              margin: "20px 0 10px",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <input
              type="text"
              placeholder="Search..."
              value={this.state.searchValue}
              onChange={this.onSearchBox}
              style={{
                padding: "8px 10px",
                fontSize: "14px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                width: "250px",
                outline: "none",
              }}
            />
          </div>

          {/* ===== Table Section ===== */}
          <div style={this.tableStyles.tableWrapper}>
            <table style={this.tableStyles.table}>
              <thead style={this.tableStyles.stickyHeader}>
                <tr style={this.tableStyles.headerRow}>
                  <th
                    style={{ ...this.tableStyles.headerCell, minWidth: "60px" }}
                  >
                    Sr.No
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "120px",
                      textAlign: "center",
                    }}
                  >
                    Outlet Code
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "140px",
                      textAlign: "left",
                    }}
                  >
                    Outlet Name
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "120px",
                      textAlign: "left",
                    }}
                  >
                    Beat Name
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "100px",
                      textAlign: "left",
                    }}
                  >
                    Town Name
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "100px",
                      textAlign: "center",
                    }}
                  >
                    Distributor SH Code
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "100px",
                      textAlign: "left",
                    }}
                  >
                    Distributor Firm Name
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "200px",
                      textAlign: "left",
                    }}
                  >
                    Error Message
                  </th>
                </tr>
              </thead>
              <tbody>
                {validatedList.length !== 0 &&
                  this.getFilteredTableData(validatedList).map((row, index) => (
                    <tr
                      key={index + 1}
                      style={{
                        ...this.tableStyles.dataRow,
                        ...this.tableStyles.alternateRow,
                        ...(index % 2 === 0
                          ? this.tableStyles.alternateRow
                          : {}),
                        ...(row.flag == 1 && { backgroundColor: "#ed8e98" }),
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor =
                          this.tableStyles.dataRowHover.backgroundColor;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor =
                          row.flag == 1
                            ? "#ed8e98"
                            : index % 2 === 0
                              ? this.tableStyles.alternateRow.backgroundColor
                              : this.tableStyles.dataRow.backgroundColor;
                      }}
                    >
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          minWidth: "60px",
                          textAlign: "center",
                        }}
                      >
                        {index + 1}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          minWidth: "120px",
                          textAlign: "center",
                        }}
                      >
                        {row?.outletCode || "-"}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          minWidth: "140px",
                          textAlign: "left",
                        }}
                      >
                        {row?.outletName || "-"}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          minWidth: "120px",
                          textAlign: "left",
                        }}
                      >
                        {row?.beatName || "-"}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          minWidth: "100px",
                          textAlign: "left",
                        }}
                      >
                        {row?.townName || "-"}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          minWidth: "100px",
                          textAlign: "center",
                        }}
                      >
                        {row?.distributorShCode || "-"}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          minWidth: "100px",
                          textAlign: "left",
                        }}
                      >
                        {row?.distributorFirmName || "-"}
                      </td>
                      {row.flag == 1 ? (
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "200px",
                            textAlign: "left",
                          }}
                        >
                          {row?.errorMessage !== null ? row?.errorMessage : "-"}
                        </td>
                      ) : (
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "200px",
                            textAlign: "left",
                          }}
                        >
                          {"-"}
                        </td>
                      )}
                    </tr>
                  ))}

                {validatedList.length === 0 && (
                  <tr>
                    <td colSpan="18" style={this.tableStyles.noData}>
                      No Data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {validatedList.length > 0 && !hasErrorRow && (
            <Grid container justifyContent="flex-end" sx={{ marginTop: 3 }}>
              <ButtonCompo
                size="medium"
                type="submit"
                variant="contained"
                name="Submit"
                onClick={this.onSubmit}
              />
            </Grid>
          )}

          {importPopUpFlag && (
            <ChangeOutletBeatImportPopUp
              open={importPopUpFlag}
              handleCloses={this.importPopUpClose}
              dataMethod={this.dataMethod}
            />
          )}
          {exportPopUpFlag && (
            <ChangeOutletBeatExportPopUp
              open={exportPopUpFlag}
              handleCloses={this.exportPopUpClose}
            />
          )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  salesPersonList: state.salesExecutive,
});

const mapDispatchToProps = {
  showLoador,
  showNotification,
  downloadExcel,
  getSalesExecutiveByUserType,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ChangeOutletBeatImportExport);
